(() => {
  function init(root = document) {
    root.querySelectorAll('.ls-slider-section').forEach((section) => {
      if (section.dataset.sliderReady === 'true') return;
      const track = section.querySelector('[data-ls-slider]');
      if (!track) return;
      section.dataset.sliderReady = 'true';
      const prev = section.querySelector('[data-ls-slider-prev]');
      const next = section.querySelector('[data-ls-slider-next]');
      const distance = () => Math.max(track.clientWidth * 0.82, 240);
      prev?.addEventListener('click', () => track.scrollBy({ left: -distance(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: distance(), behavior: 'smooth' }));
      const sync = () => {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
